import React from 'react'
import {Modal} from '@therms/atalaya'
import {useReportContext} from '@therms/react-modules'
import {MultiEntryForm} from '@src/modules/Reports/components/ViewReport/components/MultiEntryForm'

interface EntryFormModalProps {
  closeHandler?: () => void
  entryId: string
  entryTypeId: string
  formBuilderValidation?: {[key: string]: string} | undefined
  onComplete: () => void
  onFormBuilderValidate?: (errors?: {[key: string]: string}) => void
}

function EntryFormModal({
  closeHandler,
  entryId,
  entryTypeId,
  formBuilderValidation,
  onComplete,
  onFormBuilderValidate,
}: EntryFormModalProps) {
  const {reportId} = useReportContext(true)

  return (
    <Modal closeHandler={closeHandler} header="Entry" width="xl">
      <MultiEntryForm
        entryId={entryId}
        entryTypeId={entryTypeId}
        formBuilderValidation={formBuilderValidation}
        onCancel={closeHandler}
        onComplete={() => {
          closeHandler?.()
          onComplete()
        }}
        onFormBuilderValidate={onFormBuilderValidate}
        reportId={reportId}
      />
    </Modal>
  )
}

export {EntryFormModal}
